var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-page',[_c('div',{staticClass:"row"},[_c('home-slider',{attrs:{"elements":_vm.limitPopularTvshow}})],1),_c('genres')],1)}
var staticRenderFns = []

export { render, staticRenderFns }